import React from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import _ from "lodash";
import { SelectField } from "../Timps/reportfilter";
import DateRangeControl from "../../Common/DateRange/DateRangeControl";
import { Col } from "reactstrap";
import { themeService } from "../../../theme/service/activeTheme.service";
import { languageService } from "../../../Language/language.service";
import { trackReportStyle } from "../Timps/style";
import { updateFilterState } from "../../../reduxRelated/actions/filterStateAction";
import { getCurrentReportStateFilters } from "../sims/HelperFunctions/stateRetentionManagement";
import { checkFilledPush } from "../sims/reportFilter";
import SpinnerLoader from "../../Common/SpinnerLoader";
import ReportSelection from "../sims/reportSelection";
import { versionInfo } from "../../MainPage/VersionInfo";
import SvgIcon from "react-icons-kit";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import { printer } from "react-icons-kit/icomoon/printer";
import MissedAssetTestInspectionReport from "./MissedAssetTestInspectionReport";
class MissedInspectionsReport extends React.Component {
  constructor(props) {
    super(props);
    this.missedReportFilter = getCurrentReportStateFilters(this.props.missedReportFilter);
    this.state = {
      showReport: false,
      ...this.missedReportFilter,
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.handleUpdateFilterState = this.handleUpdateFilterState.bind(this);
    this.updateDateRange = this.updateDateRange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.printReport = this.printReport.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.renderReportDisplay = this.renderReportDisplay.bind(this);
  }
  handleUpdateFilterState(propertiesToUpdate) {
    let missedReportFilter = this.props.missedReportFilter ? this.props.missedReportFilter : {};

    this.props.updateFilterState("missedReportFilter", {
      ...missedReportFilter,
      ...propertiesToUpdate,
    });
  }
  componentDidMount() {
    this.state.pRange && this.state.submit && this.getRangeDataFromServer(this.state.dateRange, "&status=Missed");
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.actionType == "MISSEDREPORTS_READ_REQUEST" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: true,
      });
    }
    if (this.props.actionType == "MISSEDREPORTS_READ_SUCCESS" && this.props.actionType !== prevProps.actionType && !this.state.showReport) {
      let stateToSet = this.calculateMissedFilterData(this.props.missedReports);
      this.setState(stateToSet);
    } else if (
      this.props.actionType == "MISSEDREPORTS_READ_SUCCESS" &&
      this.props.actionType !== prevProps.actionType &&
      this.state.showReport
    ) {
      this.setState({
        reportDetailData: _.cloneDeep(this.props.missedReports),
        spinnerLoading: false,
      });
    }
    if (this.props.actionType == "MISSEDREPORTS_READ_FAILURE" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: false,
      });
    }
  }
  changeHandler(e, blur) {
    let InputObj = { ...this.state.InputObj };
    InputObj[e.target.name] = e.target.value;
    let assetReports = [];
    if (e.target.name == "assetType") {
      assetReports = this.filterByVals(e.target.value, this.state.InputObj.location, this.state.InputObj.test);
    }
    if (e.target.name == "location") {
      assetReports = this.filterByVals(this.state.InputObj.assetType, e.target.value, this.state.InputObj.test);
    }
    if (e.target.name == "test") {
      assetReports = this.filterByVals(this.state.InputObj.assetType, this.state.InputObj.location, e.target.value);
    }

    this.setState({
      InputObj: InputObj,
      reports: assetReports,
    });
  }

  calculateMissedFilterData(reports) {
    let locationOptions = [];
    let assetTypeOptions = [];
    let testsOptions = [];
    let stateToRet = {};
    let testSchedules = _.uniqBy(reports, "assetId");
    if (testSchedules && _.isArray(testSchedules)) {
      locationOptions.push({ val: "All", text: "All" });
      assetTypeOptions.push({ val: "All", text: "All" });
      testsOptions.push({ val: "All", text: "All" });
      testSchedules.forEach((test) => {
        test.testDescription = languageService("Missed Tests");
        test.title = languageService("Missed Tests");
        checkFilledPush(test.lineId, locationOptions, test.lineName);
        checkFilledPush(test.assetType, assetTypeOptions);
        checkFilledPush(test.testCode, testsOptions, test.testDescription);
      });
      stateToRet = {
        locationOptions,
        assetTypeOptions,
        testsOptions,
        reports: _.cloneDeep(testSchedules),
        InputObj: {
          location: locationOptions[0].val,
          assetType: assetTypeOptions[0].val,
          test: testsOptions[0].val,
        },
        testSchedules: _.cloneDeep(testSchedules),
        spinnerLoading: false,
      };
    } else {
      stateToRet = {
        spinnerLoading: false,
      };
    }
    return stateToRet;
  }
  filterByVals(assetType, location, test) {
    let assetReports = [...this.state.testSchedules];
    assetReports = _.filter(assetReports, (testSch) => {
      // default to true if all
      let aTypeCheck = assetType == "All" ? true : false;
      let locationCheck = location == "All" ? true : false;
      let testCheck = test == "All" ? true : false;
      // check if not true by default then calculate its validity
      !aTypeCheck && (aTypeCheck = testSch.assetType == assetType);
      !locationCheck && (locationCheck = testSch.lineId == location);
      !testCheck && (testCheck = testSch.testCode == test);
      return aTypeCheck && locationCheck && testCheck;
    });
    return assetReports;
  }
  getRangeDataFromServer(range, additionalQuery) {
    var jsonArray = encodeURIComponent(JSON.stringify(range));
    let arg = "?dateRange=" + jsonArray + (additionalQuery ? additionalQuery : "");
    this.props.getMissedReports("/getReportFilter" + arg);
  }
  handleClick(item) {
    let additionalQuery = "&assetId=" + item.assetId + "&status=Missed";
    let dateRange = this.state.dateRange;
    //additionalQuery = additionalQuery + "&testCode=" + item.testCode;
    this.getRangeDataFromServer(dateRange, additionalQuery);
    this.setState({
      showReport: true,
      reportCode: item.testCode,
      reportDescription: item.testDescription,
      testTitle: item.title ? item.title : item.testDescription,
      selectedAsset: item.assetName,
      selectedAssetType: item.assetType,
      selectedLocation: item.lineName,
      selectedAssetId: item.assetId,
    });
  }
  handleBack() {
    this.setState({
      showReport: false,
      selectedAssetType: null,
      selectedAsset: null,
      reportDetailData: [],
    });
  }
  isApp = () => localStorage.getItem("source");
  printReport() {
    document.title = this.state.reportDescription ? this.state.reportDescription : "SITE Report";
    window.print();
    let timpsSignalApp = versionInfo.isSITE();
    //window.onafterprint = function (event) {
    document.title = timpsSignalApp ? "SITE" : versionInfo.isBridge() ? "BIS" : "TIMPS";
    //};
  }
  updateDateRange(dateRange, stateRange) {
    this.setState({
      dateRange: dateRange,
      ...stateRange,
    });
    this.handleUpdateFilterState({
      dateRange: dateRange,
    });
    this.getRangeDataFromServer(dateRange, "&status=Missed");
  }
  renderReportDisplay(param, reportDetailData, selectedAsset, selectedAssetId, selectedAssetType) {
    return (
      <MissedAssetTestInspectionReport
        reportData={reportDetailData}
        locationName={this.state.selectedLocation}
        // testDescription={this.state.testTitle}
        selectedAsset={selectedAsset}
        selectedAssetType={selectedAssetType}
        selectedAssetId={selectedAssetId}
      />
    );
  }
  render() {
    let spinnerLoader = <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />;
    return (
      <div>
        {spinnerLoader}
        {!this.state.showReport && (
          <div className="mainContent" style={{ textAlign: "center" }}>
            <Col md={12}>
              <div className={"mainContent commonform"} style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
                {
                  <React.Fragment>
                    <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
                      {languageService("Missed Test Reports")}
                    </h2>
                    <span>
                      <DateRangeControl
                        dateRangeChanged={this.updateDateRange}
                        handleUpdateFilterState={this.handleUpdateFilterState}
                        iPeriod={this.state.iPeriod}
                        year={this.state.year}
                        pRange={this.state.pRange}
                        submit={this.state.submit}
                        includeScheduleOption={false}
                        includePeriod={true}
                      />
                    </span>
                    {/* <label style={themeService(trackReportStyle.labelStyle)}>{languageService("Select a Date Range")}</label>
                <span style={themeService(trackReportStyle.dateStyle)}>
                  <InputDateField updateDateRange={this.updateDateRange} defaultDate={this.state.dateRange} />
                </span> */}
                    {this.state.locationOptions && this.state.locationOptions.length > 0 && (
                      <SelectField
                        inputFieldProps={{ name: "location", label: "Location" }}
                        options={this.state.locationOptions}
                        changeHandler={this.changeHandler}
                        value={this.state.InputObj.location}
                      />
                    )}

                    {this.state.assetTypeOptions && this.state.assetTypeOptions.length > 0 && (
                      <SelectField
                        inputFieldProps={{ name: "assetType", label: "AssetType" }}
                        options={this.state.assetTypeOptions}
                        changeHandler={this.changeHandler}
                        value={this.state.InputObj.assetType}
                      />
                    )}
                    {/* {this.state.testsOptions && this.state.testsOptions.length > 0 && (
                      <SelectField
                        inputFieldProps={{ name: "test", label: "Tests" }}
                        options={this.state.testsOptions}
                        changeHandler={this.changeHandler}
                        value={this.state.InputObj.test}
                      />
                    )} */}
                  </React.Fragment>
                }
              </div>
            </Col>
            <ReportSelection reports={this.state.reports} handleClick={this.handleClick} />
          </div>
        )}
        {this.state.showReport && (
          <React.Fragment>
            <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
              <div
                className="report-arrow"
                style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                onClick={(e) => {
                  this.handleBack();
                }}
              >
                <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Reports Menu")}
                </span>
                <SvgIcon icon={arrowLeft} size={24} />
              </div>

              {!this.isApp() && (
                <div
                  className="report-print"
                  style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                  onClick={(e) => {
                    this.printReport();
                  }}
                >
                  <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                    {languageService("Print Report")}
                  </span>
                  <SvgIcon icon={printer} size={24} />
                </div>
              )}
            </div>
            {this.state.reportCode &&
              this.renderReportDisplay(
                this.state.reportCode,
                this.state.reportDetailData,
                this.state.selectedAsset,
                this.state.selectedAssetId,
                this.state.selectedAssetType,
              )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

let variables = {
  filterStateReducer: {
    missedReportFilter: null,
  },
};

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {
    updateFilterState,
  },
};
const MissedInspectionsReportContainer = CRUDFunction(
  MissedInspectionsReport,
  "missedReport",
  actionOptions,
  variables,
  ["filterStateReducer"],
  "testSchedule",
);
export default MissedInspectionsReportContainer;



// WEBPACK FOOTER //
// ./src/components/Reports/MissedInspections/MissedInpsectionsReport.jsx